import RootAboutNavigation from "./RootAboutNavigation";
export default RootAboutNavigation;
